import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import DataStrategyDecLayout from "../../components/datastrategydeclayout"
import DataStrategyDecSEO from "../../components/datastrategydecseo"
import DataStrategyDecAboutWrap from "../../components/datastrategydecaboutwrap"

import "../../style/main.scss"

import SubNav from "../../components/datastrategydecsubnav"
import About from "../../components/datastrategydecabout"
import Location from "../../components/location"

import styles from "./wrap.module.css"



const IndexPage = () => {
    const data = useStaticQuery(graphql`
      query {
        site {
          siteMetadata {
            speakers {
              name
              title
              image
              disabledProfile
              event
            }
            sponsorshipLevel
            sponsors {
              name
              level
              logo
              url
              width
              event
            }
            sessions {
              startTime
              endTime
              title
              description
              type
              speakers {
                name
                isModerator
              }
              event
            }
          }
        }
      }
    `)

  const {
    speakers,
    sessions,
    sponsors,
    sponsorshipLevel
  } = data.site.siteMetadata

  return (
    <DataStrategyDecLayout>
      <DataStrategyDecSEO title="Data Strategy 2020 | Wrap Up" />
      <SubNav />
      <DataStrategyDecAboutWrap sponsors={sponsors} sponsorshipLevel={sponsorshipLevel} />
      
    </DataStrategyDecLayout>
  )
}

export default IndexPage